<template>
  <PublicPopup ref="popupRef" padding="15px 0 0" title="Registro de Depósito">
    <template #content>
      <div class="relatorio-view">
        <div ref="filterSectionRef" class="filter-section">
          <!-- 时间筛选 -->
          <van-popover v-model:show="showTimePopover" placement="bottom-start">
            <div class="popover-h-view">
              <div v-for="subItem1 in timeOptions" :key="subItem1.value">
                <van-cell
                  :title="subItem1.label"
                  :class="{ 'cell-active': subItem1.value === itemDateType }"
                  @click="onTimeSelect(subItem1)"
                />
              </div>
            </div>
            <template #reference>
              <div class="filter-btn" :class="{ active: showTimePopover }">
                <span>{{ timeValueModal || '-' }}</span>
                <van-icon name="arrow-down" size="10" :class="{ 'icon-up': showTimePopover }" />
              </div>
            </template>
          </van-popover>

          <van-popover
            :key="'game-' + (typeEnumsList.length || 0)"
            v-model:show="showGameTypePopover"
            placement="bottom-start"
          >
            <div class="popover-h-view">
              <div v-for="e in typeEnumsList" :key="e.value">
                <van-cell
                  :title="e.label"
                  :class="{ 'cell-active': e.value === typeEnumsModal.value }"
                  @click="typeEnumsSelect(e)"
                />
              </div>
            </div>
            <template #reference>
              <div class="filter-btn" :class="{ active: showGameTypePopover }">
                <span>{{ typeEnumsModal.label || '-' }}</span>
                <span v-if="loadingEnums" class="btn-loading">...</span>
                <van-icon name="arrow-down" size="10" :class="{ 'icon-up': showGameTypePopover }" />
              </div>
            </template>
          </van-popover>
        </div>

        <div class="pull-refresh-view">
          <div v-if="dataList && dataList.length > 0" class="conta-list">
            <div v-for="(item, index) in dataList" :key="index" class="cell-item">
              <div class="chxy-row-bt">
                <div class="chxy-column">
                  <div class="chxy-row-ac">
                    <div class="item-title-sub">
                      {{ item.order_no }}
                    </div>
                  </div>
                  <div class="chxy-row-ac">
                    <div class="item-title-sub">{{ item.planned_amount }}</div>
                  </div>
                </div>
                <div class="chxy-column-end">
                  <div class="item-title-sub">{{ item.update_time }}</div>
                  <div class="item-title-sub">
                    Pix
                    <!-- {{ item.pay_channel }} -->
                  </div>
                </div>
              </div>
            </div>
            <div v-if="more" class="more-container" @click="handleUpdateList">
              <div v-if="!loading" class="more-container__content">
                <span class="text">Mais dados</span>
                <van-icon
                  name="arrow-down"
                  size="16"
                  class="arrow-down-icon"
                  style="margin-left: 2px"
                />
              </div>
              <div v-else class="more-container__content">
                <span class="text">Carregando...</span>
              </div>
            </div>
          </div>
          <div v-else class="chxy-row-c-c empty-box">
            <Empty :width="105" :height="105" />
          </div>
        </div>
      </div>
      <BJCalendar
        v-model:show="Dateshow"
        teleport="body"
        type="range"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="onConfirm"
      ></BJCalendar>
    </template>
  </PublicPopup>
  <GlobalLoading ref="loadingRef" />
</template>

<script setup>
import { rechargeOrderListApi } from '@/api/registros'
import {
  formatDateFmt,
  formatDateItem,
  formatEndTimeForApi,
  formatStartTimeForApi,
} from '@/utils/date.js'

const popupRef = ref(null)
const loadingRef = ref(null)
// 不建议 起typeEnumsModal.value的value的
// 时间类型
const timeOptions = ref([
  { label: 'Hoje', value: 0 },
  { label: 'Ontem', value: 1 },
  { label: 'Custom', value: 2 },
])
const typeEnumsList = ref([
  { label: 'Todos os Status', value: '' }, // 全部
  { label: 'Confirmando', value: 0 }, // 待确认
  { label: 'Depósito cancelado', value: 2 }, // 取消
  { label: 'Depósito Bem-sucedido', value: 1 }, // 成功
])
const timeValueModal = ref('Hoje') // 时间选中  拆成2个变量
const itemDateType = ref(0) // 时间选中 拆成2个变量 第一个时间变量
const typeEnumsModal = ref({ label: 'Todos os Status', value: '' }) // 游戏选中
const showTimePopover = ref(false)
const showGameTypePopover = ref(false)

const currentCategory = ref(null)
const filterSectionRef = ref()
const formatter = (day) => {
  switch (day.type) {
    case 'start':
      day.bottomInfo = 'Começar'
      break
    case 'end':
      day.bottomInfo = 'Fim'
      break
  }
  return day
}
// 允许从开始选（包含所有过去时间）
const now = new Date() //
const minDate = new Date(now.getTime() - 180 * 24 * 60 * 60 * 1000) // 注意：月份从 0 开始
const maxDate = new Date()

const dateSendData = ref({
  date_start: '',
  date_end: '',
})

// 时间选择  item.value == 2是自定义日历
const onTimeSelect = (item) => {
  if (item.value == 2) {
    Dateshow.value = true
  } else {
    timeValueModal.value = item.label
    itemDateType.value = item.value
    handleRefreshList()
  }
  showTimePopover.value = false
}

// 充值状态选择
const typeEnumsSelect = (item) => {
  typeEnumsModal.value = item
  showGameTypePopover.value = false
  handleRefreshList()
}

// 请求去重 id，防止竞态
const requestToken = ref(0)
// 弹窗加载指示
const loadingEnums = ref(false)

const contaList = ref([])

const dataList = ref([])
const loading = ref(false)
const more = ref(true)
const refresh = ref(false)

const pageData = reactive({
  page: 1,
  limit: 10,
})

const hideLoadingWithDelay = async () => {
  // 确保加载蒙层至少显示 300ms
  const minDisplayTime = 300
  await new Promise((resolve) => setTimeout(resolve, minDisplayTime))
  loadingRef.value?.hide()
}

const handleGetList = async () => {
  if (!loading.value) return
  const curReq = ++requestToken.value

  try {
    const params = {
      type: typeEnumsModal.value.value, // 充值类型
      start_time: '',
      end_time: '',
    }

    switch (itemDateType.value) {
      case 0:
        params.start_time = formatDateFmt(new Date(), 'yyyy-MM-dd') + ' 00:00:00'
        params.end_time = formatDateFmt(new Date(), 'yyyy-MM-dd') + ' 23:59:59'
        params.date_type = 1 // 临时补
        break
      case 1:
        params.start_time =
          formatDateFmt(new Date(new Date().getTime() - 24 * 60 * 60 * 1000), 'yyyy-MM-dd') +
          ' 00:00:00'
        params.end_time =
          formatDateFmt(new Date(new Date().getTime() - 24 * 60 * 60 * 1000), 'yyyy-MM-dd') +
          ' 23:59:59'
        params.date_type = 2 // 临时补
        break
      default:
        params.start_time = dateSendData.value.date_start
        params.end_time = dateSendData.value.date_end
    }

    const res = await rechargeOrderListApi({
      ...params,
      ...pageData,
    })
    // 如果已有更新的请求，则忽略本次响应
    if (curReq !== requestToken.value) return

    const resData = res.data
    const resList = resData.list
    const list = toRaw(dataList.value)

    more.value = pageData.page < resData.pages
    dataList.value = [...list, ...resList]
    // console.log('dataList.value:', dataList.value)

    pageData.page++
    setTimeout(() => {
      // 同样检查，防止旧请求覆盖新状态
      if (curReq !== requestToken.value) return
      loading.value = false
      if (refresh.value) refresh.value = false
      hideLoadingWithDelay() // 隐藏加载蒙层
    }, 1000)
  } catch {
    // 发生错误也需判断是否为最新请求
    const err = arguments[0]
    console.error('rechargeOrderListApi error:', err)
    if (curReq === requestToken.value) {
      loading.value = false
      if (refresh.value) refresh.value = false
      hideLoadingWithDelay() // 隐藏加载蒙层
    }
  }
}

const handleUpdateList = () => {
  if (loading.value) return
  loading.value = true
  loadingRef.value?.show() // 显示加载蒙层
  handleGetList()
}

const handleRefreshList = () => {
  if (loading.value) return
  pageData.page = 1
  loading.value = true
  loadingRef.value?.show() // 显示加载蒙层
  refresh.value = true
  dataList.value = []
  handleGetList()
}

// 自定义时间选择
const date = ref('')
const Dateshow = ref(false)
const onConfirm = (values) => {
  const [start, end] = values
  Dateshow.value = false
  date.value = `${formatDateItem(start)} - ${formatDateItem(end)}`
  dateSendData.value.date_start = formatStartTimeForApi(start)
  dateSendData.value.date_end = formatEndTimeForApi(end)
  console.log('dateSendData.value:', dateSendData.value)
  timeValueModal.value = `${formatStartTimeForApi(start)} - ${formatEndTimeForApi(end)}`
  itemDateType.value = 2
  dataList.value = []
  pageData.page = 1
  handleRefreshList()
}

// 初始化
const open = () => {
  pageData.page = 1
  dataList.value = []
  nextTick(() => {
    popupRef.value.open()
    loading.value = true
    loadingRef.value?.show() // 显示加载蒙层
    handleGetList()
  })
}

defineExpose({
  open,
})
</script>

<style scoped lang="scss">
.relatorio-view {
  width: 90vw;
  height: 60vh;

  .filter-section {
    padding: 10px 10px;
    display: flex;
    gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari */
    }
  }

  .pull-refresh-view {
    height: calc(60vh - 50px);
    overflow-y: auto;

    .conta-list {
      padding: 15px;
      height: fit-content;
    }
    .cell-item {
      width: 100%;
      border-radius: 7px;
      padding: 10px;

      &:nth-of-type(2n) {
        background: var(--bg-secondary);
      }

      .item-title {
        font-size: 11px;
        font-weight: bold;
        color: var(--record-card-title);
      }

      .item-title-sub {
        font-size: 10px;
        color: var(--record-card-value);
      }

      .item-time {
        font-size: 10px;
        color: var(--record-card-label);
      }

      .item-num {
        font-size: 10px;
        color: var(--record-card-value);
      }
      .item-desc {
        font-size: 10px;
        color: var(--record-card-label);

        .green {
          color: var(--special-green-10);
        }
      }
      .item-desc2 {
        font-size: 10px;
        color: var(--record-card-label);
      }
    }

    .more-container {
      margin-top: 10px;

      &__content {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        font-size: 12px;
        color: var(--saque-card-value);
      }
      .arrow-icon {
        color: var(--saque-arrow-down-icon);
      }
    }
  }

  .empty-box {
    height: 50vh;
  }
}

.popover-h-view {
  max-height: calc(50vh);
  margin-bottom: 20px;
  overflow-y: scroll;
  max-width: 60vw;
}

.brand-image {
  width: 17px;
  height: 8px;
  margin-right: 2px;
}

.btn-loading {
  display: inline-block;
  margin-left: 6px;
  font-size: 12px;
  color: var(--record-card-label);
}
</style>
